import type { ProjectData } from '../../types';
import Component from './content.mdx';

const data: ProjectData = {
    slug: 'WIXI',
    title: 'WIXI Cryptocurrency Exchange',
    description: 'Revolutionary cryptocurrency derivatives and margin and options trading tools are the innovative toolkit for modern investors. These options expand risk management and yield optimization possibilities, providing flexibility in developing investment strategies.',
    fileName: 'content.mdx',
    markdown: Component,
    info: {
        stack: [
            'React',
            'TypeScript',
            'Material-UI',
            'Node.js',
            'Next.js',
            'Docker',
            'PostgreSQL',
        ],
    },
};

export default data;
